/**
 * Get Content Report Items UseCase
 *
 * Fetches content report items from Firestore filtered by parentId.
 * Used by the ReportContentSheet stepper to load items at each level.
 *
 * Pattern from Flutter: ReportRepository.getContentReportItems
 * Source: lib/data/repository/report_repository.dart
 */

import { reportService } from '@/domain/services/report/reportService';
import type { ContentReportItemEntity } from '@/domain/entities/report/contentReportItemEntity';

export class GetContentReportItemsUseCase {
  /**
   * Fetch content report items by parentId
   *
   * @param parentId - null for root-level items, string ID for children
   * @returns Promise<ContentReportItemEntity[]> - Ordered list of report items
   */
  async execute(parentId: string | null): Promise<ContentReportItemEntity[]> {
    return reportService.getContentReportItems(parentId);
  }
}

export const getContentReportItemsUseCase = new GetContentReportItemsUseCase();
